export default __webpack_public_path__ + "static/media/valgt_avvik_fra_kontrollør.11092810.svg";